











import Vue from 'vue'
import ActionButton from '@/components/ActionButton.vue'

export default Vue.extend({
  name: "QuestionAudio",
  props: {
    src: String,
  },
  data(){
    return {
      audio: new Audio(this.src),
      isPlaying: false
    }
  },
  methods: {
    handleBtnClick(){
      this.audio.paused || this.audio.ended ? this.audio.play() : this.audio.pause()
    },

    // Private Methods
    _initializeAudioFromSrc(){
      this.audio.pause() 
      this.audio = new Audio(this.src)

      // Listen to audio changes and adjust view accordingly
      this.audio.onplaying = () => this.isPlaying = true
      this.audio.onended = () => this.isPlaying = false
      this.audio.onpause = () => this.isPlaying = false
    }
  },
  mounted(){
    // When component is first initialized, initialize audio
    this._initializeAudioFromSrc()
    this.audio.play() // Auto play?
  },
  watch: {
    src(newVal, oldVal){
      // When src prop changes, reinitialize audio
      this._initializeAudioFromSrc()
      this.audio.play() // Auto play?
    }
  },
  beforeDestroy(){ this.audio.pause() },
  components: { ActionButton }
})
